export default {
  ALL: "filterMatch_ALL",
  ANY: "filterMatch_ANY",
  NONE: "filterMatch_NONE"
};
